export const saveButtonWordings = {
  save: "Save",
  saveAndClose: "Save & Close",
  revert: "Revert",
  cancel: "Cancel",
};
